import { data } from '../../svg/Relations/data';
import { makeIcon } from '../makeIcon';

export const Relations = makeIcon(data, 'relations', 'Relations');

export default Relations;
